import { render } from "./MailingBlockSpacerEditor.vue?vue&type=template&id=63e62ac0"
import script from "./MailingBlockSpacerEditor.vue?vue&type=script&lang=js"
export * from "./MailingBlockSpacerEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__